import { jsx } from "react/jsx-runtime";
import { Link } from "pcln-design-system";
import "react";
import { handleRentalCarBookNowClick } from "./handleRentalCarBookNowClick.js";
import { rentalCarRateOptionsManager } from "./rentalCarRateOptionsManager.js";
const RentalCarBookNowLink = ({ rateId, isMobile, cguid, rguid })=>{
    const rentalCarRate = rentalCarRateOptionsManager.getRentalCarByRateId(rateId);
    if (rentalCarRate && rentalCarRate?.detailsInfo?.itemKey && rentalCarRate?.detailsKey) return /*#__PURE__*/ jsx(Link, {
        href: "#",
        onClick: handleRentalCarBookNowClick({
            rentalCarRate,
            isMobile,
            cguid,
            rguid
        }),
        children: "Book Now"
    });
    return null;
};
export { RentalCarBookNowLink };
